import { Capacitor } from '@capacitor/core';

// Where on-device sticker generation is allowed.
// - web: @imgly WASM works fine.
// - iOS 17+: native Vision plugin (VNGenerateForegroundInstanceMaskRequest).
//   iOS ≤ 16 has no general subject-lift API, and the WASM path crashes the
//   WKWebView, so stickers stay disabled there.
// - Android: no native segmenter yet — disabled.
// This gates GENERATION only; already-saved stickers still render everywhere,
// and the LLM analysis/tags/logging are server-side and unaffected.
export function stickersSupported(): boolean {
  const platform = Capacitor.getPlatform();
  if (platform === 'web') return true;
  if (platform === 'ios') {
    const match = navigator.userAgent.match(/ OS (\d+)_/);
    return match ? parseInt(match[1], 10) >= 17 : false;
  }
  return false;
}
